import { forwardRef, type InputHTMLAttributes } from 'react'

import { Search01Icon } from '@hugeicons/react'
import clsx from 'clsx'

import { cn } from '@/lib/utils'

import { controlVariants, type ControlSize } from './control-styles'

type SearchInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> & {
  containerClassName?: string
  size?: ControlSize
}

/** Campo de busca — ícone + `controlVariants` (borda `border-contour`). */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  function SearchInput(
    { className, containerClassName, size = 'md', ...props },
    ref
  ) {
    return (
      <div className={clsx('relative min-w-0', containerClassName)}>
        <Search01Icon
          size={16}
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-gray-500"
          aria-hidden
        />
        <input
          ref={ref}
          type="search"
          className={cn(controlVariants({ size }), 'pl-9', className)}
          {...props}
        />
      </div>
    )
  }
)

SearchInput.displayName = 'SearchInput'

export default SearchInput
